import styled from 'styled-components';

const appearances: Record<string, { label: string; background: string }> = {
  방송중: { label: 'Live', background: '#d92d20' },
  '방송 중': { label: 'Live', background: '#d92d20' },
  리허설: { label: 'Test', background: '#7955f0' },
  종료: { label: 'Finish', background: '#6b7280' },
  예약: { label: '예약', background: '#2563eb' },
};

export default function LiveStatusBadge({ status, className }: { status?: string; className?: string }) {
  const { label, background } = appearances[status || ''] || {
    label: status || '준비', background: '#6b7280',
  };

  return <Badge className={className} $background={background}>{label}</Badge>;
}

const Badge = styled.span<{ $background: string }>`
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  align-self: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 4px;
  background: ${({ $background }) => $background};
  color: #fff;
  font-family: var(--font-Pretendard-SemiBold), sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  text-transform: none;
`;
